import React, { useEffect, useState, useRef, forwardRef, useImperativeHandle, useCallback } from 'react';

import ReactPlayer from 'react-player';
import WaveSurfer from "wavesurfer.js";
import './VideoComponent.css'
import PauseIcon from '@mui/icons-material/Pause';
import PlayArrowIcon from '@mui/icons-material/PlayArrow';
import Replay5Icon from '@mui/icons-material/Replay5';
import Forward5Icon from '@mui/icons-material/Forward5';
import Begin from '@mui/icons-material/FirstPage';
import $ from 'jquery';
import{dBConn} from './API_GET'

let videoReady = false;
let audioReady = false;

const url = window.location.href;


let width = 500;
let top = 250;
let left = 110;
let height = 110;
let disabledDrag = false; // Variabile globale per il controllo del drag
let showModal = false;
let portalWindow = false
let showWaveformBase = false
let debounceTimer
let rememberData 

if(url.endsWith('AudioMateVPlayer')){
    width = '100%';
    top = 0;
    left = 0;
    disabledDrag = true;
    showModal = true
    portalWindow = true
    showWaveformBase = true
}  


export const VideoComponent = forwardRef((props, ref) => {
  
  const playerRef = useRef(null);
  const cardRef = useRef(null);
  
  const [currentCursorPosition, setCurrentCursorPosition] = useState('---');
  const [totalLength, setTotalLength] = useState('---');
  const paramsS3 = useRef({});
  const dragRef = useRef(null);
  const resizeRef = useRef(null);
  const playerDivRef = useRef(null);
  const waterMarkDivRef = useRef(null);
  const waterMarkRef = useRef(null);
  const aspectRatio = useRef(null);
  const [showWaterMark, setShowWaterMark] = useState(false);


  const [videoSettings, setVideoSettings] = useState({
    partialVideoUrl: '',
    videoUrl: '',
    showModal: showModal,
    width: width,
    showWaveform: showWaveformBase,
    loadingWaveform: true,
    inplay: false,
    filename: '',
    position: { x: left, y: top }
  })
  
    useEffect(() => {
      if(portalWindow){
        window.addEventListener('load', handleCompleteLoad);
        window.addEventListener('message', handleMessage);
      }
    return () => {
      if(portalWindow){
        window.removeEventListener('message', handleMessage);
        window.removeEventListener('load', handleCompleteLoad);
      }
  
    }
  }, [])

 

    // Drag of the Window
    const handleMouseDown = (e) => {
        e.preventDefault();

        const initialMouseX = e.clientX;
        const initialMouseY = e.clientY;
        const initialElementX = videoSettings.position.x;
        const initialElementY = videoSettings.position.y;

        const handleMouseMove = (e) => {
            const deltaX = e.clientX - initialMouseX;
            const deltaY = e.clientY - initialMouseY;

            setVideoSettings(prevSettings => ({
              ...prevSettings,
              position: {
                x: initialElementX + deltaX,
                y: initialElementY + deltaY
              }
          }));
      }

    const handleMouseUp = () => {
        window.removeEventListener('mousemove', handleMouseMove);
        window.removeEventListener('mouseup', handleMouseUp);
    };

        window.addEventListener('mousemove', handleMouseMove);
        window.addEventListener('mouseup', handleMouseUp);
};

  // resize
  const handleResizeMouseDown = (e) => {
    e.preventDefault();

    const initialMouseX = e.clientX;
    const initialMouseY = e.clientY;
    const initialWidth = videoSettings.width;
    const initialHeight = videoSettings.height;

    const handleMouseMove = (e) => {
      const deltaX = e.clientX - initialMouseX;
      const deltaY = e.clientY - initialMouseY;

      setVideoSettings(prevSettings => ({
        ...prevSettings,
        width: Math.max(initialWidth + deltaX, 350),  
        height: Math.max(initialHeight + deltaY, 100) 
      }));
      //resizeWatermark();
    };

    const handleMouseUp = () => {
        window.removeEventListener('mousemove', handleMouseMove);
        window.removeEventListener('mouseup', handleMouseUp);
    }

      window.addEventListener('mousemove', handleMouseMove);
      window.addEventListener('mouseup', handleMouseUp);
  }


    const handleCompleteLoad = () => {};

    const handleMessage = (props) => {
      if(props.data.playInfo){

        rememberData = {
          filename: props.filename,
          url: props.url
        }
        setVideoSettings(previous => ({
          ...previous,
          partialVideoUrl: props.data.playInfo.url,
          filename: props.data.playInfo.filename,
        }))
      }
      if(props.data.shortCut){
        if(props.data.shortCut === 'playPause'){
          pausePlay();
        }
        if(props.data.shortCut === 'ArrowLeft'){
          goback5Seconds()
        }

        if(props.data.shortCut === 'ArrowRight'){
          goforward5Seconds()  
        }
      }
      
    }
  
  const wavesurferRef = useRef(null);

    /* handle audio ready */
    const handleAudioLoaded = useCallback(() => {
      setVideoSettings(previous => ({
        ...previous,
        loadingWaveform: false
      }))
      audioReady = true;
      playBoth()
      
    },[]);

    window.addEventListener('resize', resizePortalWindow);

    /* general useEffect */
    useEffect(() => {
      window.addEventListener('resize', resizePortalWindow);
      window.addEventListener('beforeunload', () => {
        interactionWithScript({action: {type: 'destroy'}})
      });

      return () => {
        window.removeEventListener('resize', resizePortalWindow);
      }
  }, []);


  /* USE EFFECT FOR WAVESURFER*/
  useEffect(() => {

    if(videoSettings.showModal){
      wavesurferRef.current = WaveSurfer.create({
        container: '#videowaveform', 
        waveColor: '#3498db',
        progressColor: '#999',
        height: 60,
        width: '100%',
        fillParent: true,
        splitChannels: true,
        volume: 0
      });
      videoReady = false;
      audioReady = false;

      return () => {
        wavesurferRef.current.destroy();
      };
  }
  }, [videoSettings.partialVideoUrl, videoSettings.showModal]);

  

  function resetUrl(){
      paramsS3.current = {}
      setShowWaterMark(false);
  }

  function refreshWave(){
      wavesurferRef.current.load(playerRef.current.getInternalPlayer());
  } 


  useEffect(() => {

    setVideoSettings(previous => ({
      ...previous,
      loadingWaveform: true
    }))

    const baseKey = videoSettings.partialVideoUrl;

    if(videoSettings.partialVideoUrl){

        setCurrentCursorPosition('---');
        setTotalLength('---');

        dBConn.post('getVideoFiles', {baseKey: 'projects-audiomate/' + baseKey}).then((response) => {

            videoSettings.partialVideoUrl = response.selectedKey;
            setVideoSettings(previous => ({
              ...previous,
              videoUrl: response.link,
              showModal: true,
            }))
        
            wavesurferRef.current.on('ready', function(){
                var isStereo = wavesurferRef.current.backend.buffer.numberOfChannels > 1;

                if (isStereo) {
                    // If stereo, reduce the height
                    wavesurferRef.current.params.height = 30;
                } else {
                    // If mono, increase height (or keep default)
                    wavesurferRef.current.params.height = 60;
                }       
                // Render the waveform with the new height
                wavesurferRef.current.drawBuffer();

                handleAudioLoaded()
            })

            wavesurferRef.current.setVolume(0);
            wavesurferRef.current.on('seek', handleInteraction);
            wavesurferRef.current.on('audioprocess', () => {
                const currentPosition = wavesurferRef.current.getCurrentTime();
                setCurrentCursorPosition(formatTime(currentPosition));
                setVideoSettings(previous => ({
                    ...previous,
                    inplay: true
                }))
            });

        }
    )}
  } , [videoSettings.partialVideoUrl]);

  useEffect(() => {

    window.addEventListener('keydown', playerKeyDown);
    
    return () => {
      window.removeEventListener('keydown', playerKeyDown);
    }

  }, [])

  function playerKeyDown(props){
    try{
      if(props.shiftKey){
        if(props.key === ' '){
          pausePlay()  
        }
        if(props.key === 'ArrowLeft'){
          goback5Seconds()
        }
        if(props.key === 'ArrowRight'){
          goforward5Seconds()  
        }
      }
    }
    catch(err){}

  }
        
  useImperativeHandle(ref, () => ({
    playVideo(props) {

      rememberData = {
        filename: props.filename,
        url: props.url
      }

      setVideoSettings(previous => ({
        ...previous,
        partialVideoUrl: props.url,
        showModal: true,
        filename: props.filename,
      }))

    }
  }));

  

  function resizePortalWindow(event) {
    clearTimeout(debounceTimer); // Delete the existing timer to prevent the previous execution
    debounceTimer = setTimeout(() => {
      if ($('.videoplayerContainer').is('.portal')) {


        const modalHeight = $(document).height()
        const videoContainer = $('#videoPlayerPlace')
        const startVideoHeight = videoContainer.offset().top;

        const resultHeight = modalHeight - startVideoHeight - 20;

        videoContainer.height(resultHeight)

        //resizeWatermark();
        wavesurferRef.current.drawBuffer();
      }
    }, 500);
  }
  

  /* player config */
  const playerConfig = {
    file: {
      attributes: {
        onContextMenu: e => e.preventDefault(), // disable right click
        controlsList: 'nodownload nofullscreen',// disable download
        disablePictureInPicture: true // disable PictureInPicture mode
      }
    }
  } 

  const interactionWithScript = (props) => {
    if($('.videoplayerContainer').is('.portal')){
        window.postMessage(props, '*');
    }
}

  /* close the UI */   
  function closeVideoUI(){
    // Save the current position in global variables
    if (videoSettings.position) {
      left = videoSettings.position.x;
      top = videoSettings.position.y;
    }
    
    // Reset dello state con la posizione preservata
    setVideoSettings(previous => ({
      videoUrl: '',
      partialVideoUrl: '',
      showModal: false,
      width: width,
      filename: '',
      position: previous.position 
    })) 
    resetUrl();
  }

  /* handle video ready */
  const handleVideoReady = () => {    
    videoReady = true;
    setShowWaterMark(true);
    playBoth()
    // Code to be performed when the video is ready for the play
  };

  /* play once all the instances are ready */
  const playBoth = () => {
    if(videoReady && audioReady){
      setTotalLength(formatTime(wavesurferRef.current.getDuration()))
      wavesurferRef.current.play(playerRef.current.getCurrentTime())
      if(!playerRef.current.player.isPlaying){ wavesurferRef.current.pause() }
    } else if(videoReady) {
      playerRef.current.getInternalPlayer().play()
    }
  }

  /* play */
  function onPlayHandler(props){
    setVideoSettings(previous => ({
      ...previous,
      inplay: true
    }))
    
      wavesurferRef.current.play()
  }

  /* pause */
  function onPauseHandler(){
    setVideoSettings(previous => ({
      ...previous,
      inplay: false
    }))
      wavesurferRef.current.pause()
  }

  /* seek */
  function handleInteraction(e){
    playerRef.current.seekTo(wavesurferRef.current.getCurrentTime())
    if (wavesurferRef.current.isPlaying()) {
      wavesurferRef.current.play();
    }       
  }

  /* seek from video player */
  function handleVideoProgress(progress){
    /* change position to wavesurfer without playing */
    wavesurferRef.current.play(progress)
    if(!playerRef.current.paused){
      playerRef.current.getInternalPlayer().play()
    } else {
      playerRef.current.stop()
    }
  }

  /* go to start */
  const gotoStart = () => {
    wavesurferRef.current.seekTo(0)
    playerRef.current.seekTo(0)
  }
  
  /* go back 5 seconds */
  const goback5Seconds = () => {
    const newTime = playerRef.current.getCurrentTime() - 5;
    playerRef.current.seekTo(newTime, 'seconds')

  }

    /* go forward 5 seconds */
    const goforward5Seconds = () => {
      const newTime = playerRef.current.getCurrentTime() + 5;
      playerRef.current.seekTo(newTime, 'seconds')
      //wavesurferRef.current.skipForward(5)
    }

  /* play control */
  const playControl = () => {
    setVideoSettings(previous => ({
      ...previous,
      inplay: true
    }))
    wavesurferRef.current.play()
    playerRef.current.getInternalPlayer().play()
  }
  
  /* pause */
  const pauseControl = () => {
    setVideoSettings(previous => ({
      ...previous,
      inplay: false
    }))
    wavesurferRef.current.pause()
    playerRef.current.getInternalPlayer().pause()
  }

  

  const pausePlay = () => {
    if($('.pauseB').is('.btn-outline-danger')){
      pauseControl()
    } else {
      playControl()
    }
  }
 
  /* draw the waveform */

  //const resizeWatermark = () => {
  //  const element = document.getElementById('videoPlayerPlace');
  //  //const video = document.getElementById('videoPlayerPlace');

  //  const height = element.clientHeight;
  //  const element2 = document.getElementById('videoWatemark');
  //  element2.style.height = height - 70 + 'px';

  //  let watemarkText = 'Keywordsstudios.com'
  //  for(let i = 0; i < 100; i++){
  //    watemarkText = watemarkText + ' Keywordsstudios.com'
  //  }
  //  updateWatermark(watemarkText, height)
  //}

  function updateWatermark(newText, heigth) {
    document.documentElement.style.setProperty('--watermark-text-size', `${heigth / 10}px`);
    document.documentElement.style.setProperty('--watermark-text', `"${newText}"`);
  }

  // We use the top and Left global variables for the initial position
  // To avoid errors when Videosettings.position is Undefined
  const cardStyle = {
    width: videoSettings.width, 
    cursor: 'default', 
    position: 'fixed', 
    top: videoSettings.position ? videoSettings.position.y : top, 
    left: videoSettings.position ? videoSettings.position.x : left,
    zIndex: '10000',
  }

  const showWaveform = () => {
    setVideoSettings(previous => ({
      ...previous,
      showWaveform: !previous.showWaveform
    }))
    resizePortalWindow()
  }

  function changePositionPlayer(){
        closeVideoUI()
        props.onDetachState(rememberData)
    }

    const fullScreen = {width: '100%', height: '100%'}
    
    useEffect(() => {
      const resizeWatermark = () => {
        if(!waterMarkRef.current) return;
        const internal = playerRef.current?.getInternalPlayer();
        if (internal && internal.videoWidth && internal.videoHeight) {
          const width = internal.videoWidth;
          const height = internal.videoHeight;
          aspectRatio.current = (width / height).toFixed(2);
          const videoWidth = playerRef.current.wrapper.firstElementChild.clientWidth;
          const videoHeight = playerRef.current.wrapper.firstElementChild.clientHeight;
          let fontWidth = videoWidth;
          if((videoWidth/videoHeight) > aspectRatio.current) {
            fontWidth = videoHeight * aspectRatio.current;
            waterMarkDivRef.current.style.height = videoHeight + 'px';
            waterMarkDivRef.current.style.width = (fontWidth) + 'px';
          } else {
            waterMarkDivRef.current.style.width = videoWidth + 'px';
            waterMarkDivRef.current.style.height = (videoWidth / aspectRatio.current) + 'px'; 
          }
          waterMarkRef.current.style.fontSize = (fontWidth * 0.1) + 'px';
        }
      }
      const observer = new ResizeObserver(resizeWatermark);
      if(showWaterMark && playerDivRef.current) {     
          observer.observe(playerDivRef.current);
        resizeWatermark(); 
      } else {
        observer?.disconnect();
      }
      
    }, [showWaterMark])
  
    return (
      videoSettings.showModal ? (
          <div ref={dragRef} className="videoplayerContainer" 
          style={{
            position: disabledDrag ? 'fixed' : 'fixed', // Posiziona l'elemento in modo assoluto o fisso
            top: disabledDrag ? 0 : videoSettings.position.y, // Usa la posizione dal tuo stato
            left: disabledDrag ? 0 : videoSettings.position.x, // Usa la posizione dal tuo stato
            zIndex: '10000',
            ...disabledDrag ? fullScreen : {}
          }}
          >
            <div className="card videoplayer" style={{width: videoSettings.width}}>
              <div id="draggableVideo" onMouseDown={handleMouseDown} >
                <button className="btn detatableIcon" onClick={changePositionPlayer} title="Detach video player"><i className="bi bi-back"></i></button>
                <button type="button" className="crossClose btn-close closeUI" onClick={closeVideoUI}></button>
                <h6 className="card-title">Video Player: {videoSettings.filename}</h6>
              </div>
              <div id="audioPlayerPlace" style={videoSettings.showWaveform ? {display: 'block'} : {display: 'none'}}>
                {videoSettings.loadingWaveform &&
                  <div id="coverLoading">
                    <div>Loading...</div>
                  </div>
                }
                <div id="videowaveform"></div>
                <span>Cursor: {currentCursorPosition}</span>
                <span style={{float: 'right'}}>Duration: {totalLength}</span>
              </div>

              <div className="controls">
                <div className="btn-group mr-2 btn-group-sm playersControls" role="group">
                  <button 
                    className="btn btn-outline-secondary btn-sm"
                    onClick={gotoStart}
                    title="Rewind"
                    ><Begin /></button>
                  <button 
                    className="btn btn-outline-secondary btn-sm"
                    onClick={goback5Seconds}
                    title="Go back 5 seconds (Shift + Left Arrow)"
                    ><Replay5Icon /></button>
                  <button 
                    className={videoSettings.inplay ? "btn btn-primary btn-sm" : "btn btn-outline-primary btn-sm"}
                    onClick={playControl}
                    title="Play (Shift + Space)"
                    ><PlayArrowIcon /></button>
                  <button 
                    className={!videoSettings.inplay ? "btn btn-danger pauseB btn-sm" : "btn btn-outline-danger pauseB btn-sm"}
                    onClick={pauseControl}
                    title="Pause (Shift + Space)"
                    ><PauseIcon /></button>
                  <button 
                    className="btn btn-outline-secondary btn-sm"
                    onClick={goforward5Seconds}
                    title="Go forward 5 seconds (Shift + Right Arrow)"
                    ><Forward5Icon /></button>
                  {/*<button 
                    className="btn btn-outline-secondary btn-sm"
                    onClick={showWaveform}
                    title="Show Audio Waveform">
                      <i className="bi bi-soundwave" style={{position: 'relative', fontSize: '18px', top: '2px'}}></i>
                    </button>*/}
                    
                </div>
              </div>
              
              <div ref={playerDivRef} id="videoPlayerPlace">
                {showWaterMark && 
                  <div ref={waterMarkDivRef} className='kw-video-watermark-div'>
                    <div ref={waterMarkRef} className='kw-video-watermark'>Keywords Studios</div>
                  </div>
                }
                <ReactPlayer 
                  ref={playerRef} 
                  url={videoSettings.videoUrl}
                  onReady={handleVideoReady}
                  controls={true}
                  config={playerConfig}
                  width='100%' height='100%'
                  onPlay={onPlayHandler}
                  onPause={onPauseHandler}
                  onSeek={(progress) => handleVideoProgress(progress)}
                  />
                
              </div>

            </div>
            
            {!disabledDrag && <div
                  ref={resizeRef}
                  className="resize-handle"
                  onMouseDown={handleResizeMouseDown} // Gestisce il click per iniziare a ridimensionare
              ><i className="bi bi-grip-horizontal"></i></div>}

          </div>

      )
      : null
    )
})

// how to implement the video component in another component 
/*
  1. import the component

      import {VideoComponent} from './VideoComponent';

  2. create a ref

      const player = useRef(null);

  3. add the VideoComponent to the component
  
        <VideoComponent ref={player} />

  4. call the function playVideo with the S3 url of the video

      function playVideo(partialVideoUrl){
        player.current.playVideo(partialVideoUrl)
      }
*/

/* function to convert seconds to HH:MM:SS:ms */

function formatTime(seconds) {
  const hours = Math.floor(seconds / 3600);
  const minutes = Math.floor((seconds % 3600) / 60);
  const remainingSeconds = Math.floor(seconds % 60);
  const milliseconds = Math.floor((seconds - Math.floor(seconds)) * 1000);

  let formattedTime = '';

  if (hours > 0) {
    formattedTime += `${hours.toString().padStart(2, '0')}:`;
  }

  formattedTime += `${minutes.toString().padStart(2, '0')}:`;
  formattedTime += `${remainingSeconds.toString().padStart(2, '0')}`;
  
  if (milliseconds > 0) {
    formattedTime += `.${milliseconds.toString().padStart(3, '0')}`;
  }

  return formattedTime;
}

export const visibleVPlayer = () => {
  $('.videoplayerContainer').addClass('portal');
  window.name = 'AudioMate Video Player';
  document.title = window.name;
}